export default "<app-contact-info></app-contact-info>"